import { createAction } from '@reduxjs/toolkit';

export const FETCH_VIDEO_CREDS_ACTION_TYPE = 'saga/fetchvideocreds';
export const fetchVideoCredsAction = createAction(FETCH_VIDEO_CREDS_ACTION_TYPE);
